import { render, staticRenderFns } from "./shopDriver.vue?vue&type=template&id=2128c17c&"
import script from "./shopDriver.vue?vue&type=script&lang=js&"
export * from "./shopDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports